// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__-aGB-","active":"NavigationItem_active__2dnes"};